import React from 'react';
import { dispatch } from 'nike-re-framejs';
import { Button } from 'nike-ui/src/components/button/Button';

import i18n from '@i18n';
import TrashIcon from '@/icons/TrashIcon';
import { deleteInLS } from '@/mytickets/saved/utils';
import PopupNg from '@/ui/PopupNg';

function DeleteSavedOnDevice({ ticket }) {
    function onClick() {
        PopupNg.dispatcher.close('ticketDetail');
        deleteInLS(ticket.ticketId);
        dispatch(['history_back']);
    }
    return <Button className="red" icon={TrashIcon} label={i18n('commons.button.zrusitTiket')} onClick={onClick} />;
}
export default DeleteSavedOnDevice;
